import { render, staticRenderFns } from "./excess-form.vue?vue&type=template&id=77f0bcde&scoped=true&"
import script from "./excess-form.vue?vue&type=script&lang=js&"
export * from "./excess-form.vue?vue&type=script&lang=js&"
import style0 from "./excess-form.vue?vue&type=style&index=0&id=77f0bcde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f0bcde",
  null
  
)

export default component.exports